export default "__VITE_ASSET__JT9IKO86__"